module.exports = __webpack_public_path__ + "img/kleisma1.09966256.jpg";